import { useCallback, useMemo, useState } from 'react';
import type { WebhookProviderConfigDraft } from '../types';
import { createDefaultWebhookProviderConfigDraft } from '../webhook-config-draft';

/** Local owned draft for create flows (e.g. trigger drawer) without a persisted trigger. */
export function useWebhookProviderConfigDraft(options?: {
  initial?: Partial<WebhookProviderConfigDraft>;
}): {
  draft: WebhookProviderConfigDraft;
  patchDraft: (patch: Partial<WebhookProviderConfigDraft>) => void;
  resetDraft: (next?: Partial<WebhookProviderConfigDraft>) => void;
} {
  const [ownedBase, setOwnedBase] = useState<WebhookProviderConfigDraft>(
    () => ({
      ...createDefaultWebhookProviderConfigDraft(options?.initial?.providerKey),
      ...options?.initial,
    })
  );
  const [overrides, setOverrides] = useState<
    Partial<WebhookProviderConfigDraft>
  >({});

  const draft = useMemo(
    () => ({ ...ownedBase, ...overrides }),
    [ownedBase, overrides]
  );

  const patchDraft = useCallback(
    (patch: Partial<WebhookProviderConfigDraft>) => {
      setOverrides((current) => ({ ...current, ...patch }));
    },
    []
  );

  const resetDraft = useCallback(
    (next?: Partial<WebhookProviderConfigDraft>) => {
      setOwnedBase({
        ...createDefaultWebhookProviderConfigDraft(next?.providerKey),
        ...next,
      });
      setOverrides({});
    },
    []
  );

  return { draft, patchDraft, resetDraft };
}
